<template>
  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
    msg-information="Pour compléter ce tableau, indiquez dans la colonne Montant HT le coût unitaire du badge ou de la carte (en €), et dans la colonne Quantité le nombre de badges ou de cartes."
  />
</template>

<script setup lang="ts">
  import { FraisFormation } from '@/features/interface/demande/shared'

import { storeToRefs } from 'pinia'
import { useDemandeOutilFPEActions } from '../../../../useDemandeOutilFPEActions.ts'
import { useDemandeOutilFPEStore } from '../../../../useDemandeOutilFPEStore.ts'

  const store = useDemandeOutilFPEStore()

  const { readonly } = storeToRefs(store)

  const { modifieFrais, fraisDataParMode } = useDemandeOutilFPEActions()
</script>
